import React from 'react';
import { ImagePlaceholder as ImagePlaceholderImg } from '@producer/ui-kit';

import { PhotoUploader } from '../photo-uploader/photo-uploader';

import styles from './image-placeholder.module.scss';

interface ImagePlaceholderProps {
  onChange?: (file: File) => void;
}

export const ImagePlaceholder: React.FC<ImagePlaceholderProps> = ({ onChange }) => (
  <>
    {onChange ? (
      <PhotoUploader accept="image/png, image/jpg, image/jpeg, image/webp" onChange={onChange} />
    ) : (
      <div className={styles['replacement-image']}>
        <ImagePlaceholderImg />
      </div>
    )}
  </>
);
